import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
    id: string;
    handleClick: () => void;
    text: string;
    icon: ReactNode;
    className?: string;
    innerClassName?: string;
    textClassName?: string;
};

const PersonaTile: FC<Props> = ({ id, handleClick, text, icon, className, innerClassName, textClassName }) => {
    return (
        <button
            id={id}
            className={twMerge('tw-mb-3 tw-w-full !tw-bg-transparent tw-px-3 lg:tw-w-1/2', className)}
            onClick={handleClick}
        >
            <div
                className={twMerge(
                    'tile-inner tw-flex tw-min-h-[80px] tw-flex-row tw-items-center tw-overflow-hidden tw-rounded-lg tw-border-2 tw-border-solid !tw-border-navy-600 !tw-bg-navy-600 tw-px-3 tw-py-2 hover:tw-border-teal-400 hover:tw-shadow-[0_0_16px_rgba(1,9,12,0.08)] group-focus:!tw-bg-transparent md:tw-h-full',
                    innerClassName
                )}
            >
                {icon}
                <div className={twMerge('tw-ml-2 tw-flex tw-items-center tw-text-left', textClassName)}>
                    <p
                        className={'graphik-semibold tw-text-base tw-leading-[24px] tw-text-white md:tw-text-[18px]'}
                    >{`${text} `}</p>
                </div>
            </div>
        </button>
    );
};

export default PersonaTile;
